<div style="z-index: 1003; display: block; opacity: 1; transform: scaleX(1); top: 10%;
cursor: move;">
    <div class="modal-header">
        <h4 class="modal-title" translate>lblNewCheckInConfirmation</h4>
    </div>
    <div class="modal-body">
        <div class="form-group">
            <label class="control-label pb-2" translate>lblEnterRegistrationNo</label>
            <input class="form-control control-label" name="txtLpnumber" type="text" [(ngModel)]="name" autocomplete="off" (keyup.enter)="onOK()">
            <label class="control-label" [ngClass]="{'lpError': errormessage, 'lpNoError': !errormessage || name}" translate>{{errormessage}}</label>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary m-0" aria-label="Center Align" (click)="onOK()">
            <span translate>lblOk</span>
          </button>
    </div>
</div>